var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaginationRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 11.2 4.812 C 11.2 5.144 10.931 5.412 10.6 5.412 L 2.089 5.412 L 5.416 8.58 C 5.578 8.727 5.647 8.951 5.596 9.163 C 5.546 9.376 5.384 9.545 5.173 9.603 C 4.962 9.661 4.737 9.601 4.584 9.444 L 0.184 5.244 C 0.066 5.131 0 4.975 0 4.812 C 0 4.649 0.066 4.494 0.184 4.38 L 4.584 0.18 C 4.737 0.024 4.962 -0.037 5.173 0.022 C 5.384 0.08 5.546 0.249 5.596 0.461 C 5.647 0.674 5.578 0.898 5.416 1.044 L 2.089 4.212 L 10.6 4.212 C 10.931 4.212 11.2 4.481 11.2 4.812 Z",
    transform: "translate(2.4 3.188) rotate(180 5.6 4.812)",
    fill: "rgba(108, 114, 132, 0.3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationRight);
export default __webpack_public_path__ + "static/media/PaginationRight.5787d1c6426f7c96094a4e9741bce2bc.svg";
export { ForwardRef as ReactComponent };